import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { NgxMaskDirective} from "ngx-mask";
import { MaskEditField } from "src/app/interfaces/user-authentication";
import { StringUtils } from "../StringUtils";

@Directive({
    selector: '[custom-mask]',
    standalone: false
})
  export class CustomMaskDirective  implements AfterViewInit{
  
    @Input('custom-mask') customMask: MaskEditField;
    @HostBinding('attr.mask') mask : string;
    // Attached directives can be injected, just like template-declared directives today
    constructor( private el: ElementRef) {
    } 
  
    ngAfterViewInit(): void {
      (this.el.nativeElement as Element).setAttribute("mask","0.0.0");
    }
  
    
  
  }